/* unplugin-vue-components disabled */import script from "./internalGoods.vue?vue&type=script&setup=true&lang=ts"
export * from "./internalGoods.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__